import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router";

import { addNoScroll, removeNoScroll } from "../../utilities";

export default function BodyNoScroll({ isActive, children = null }) {
  const location = useLocation();

  const isMounted = useRef(false);

  useEffect(() => {
    if (isActive) {
      addNoScroll();
    }
    return removeNoScroll;
  }, []);

  useEffect(() => {
    if (isMounted.current) {
      removeNoScroll();
    } else {
      isMounted.current = true;
    }
  }, [location]);

  useEffect(() => {
    if (isActive) {
      addNoScroll();
    } else {
      removeNoScroll();
    }
  }, [isActive]);

  return <>{children}</>;
}
